import IntlMessageFormat from 'intl-messageformat';
import IDict from 'q2-tecton-common/lib/types/dict';
import { BehaviorSubject } from 'rxjs';
import defaultStrings from '../utility/default-strings';

export interface DesignSystemLanguageAPI {
    loc(key: string, substitutions?: IDict<any> | string[], options?: IDict<any>): string;
    changeLanguage(newLanguage: string, newLanguageTranslations?: IDict<string>): void;
}
export function designSystemTranslationSetup(
    initalLanguage?: string,
    initialTranslations?: IDict<IDict<string>>
): DesignSystemLanguageAPI {
    // set initialLanguage if passed otherwise leave on out of box english
    const language$: BehaviorSubject<string> = new BehaviorSubject('en-US');
    const currentTranslations: IDict<IDict<string>> = defaultStrings;

    if (initalLanguage) {
        language$.next(initalLanguage);
    }

    // add translations if passed to translation cache
    if (initialTranslations) {
        for (const langKey in initialTranslations) {
            if (initialTranslations.hasOwnProperty(langKey)) {
                // combine with default translations only overwriting on a per key basis
                currentTranslations[langKey] = {
                    ...(currentTranslations[langKey] || {}),
                    ...initialTranslations[langKey]
                };
            }
        }
    }

    return {
        loc: loc.bind(null, language$, currentTranslations),
        changeLanguage: changeLanguage.bind(null, language$, currentTranslations)
    };
}

export function loc(
    language$: BehaviorSubject<string>,
    currentTranslations: IDict<IDict<string>>,
    key: string,
    substitutions?: IDict<any> | string[],
    options?: IDict<any>
): string {
    // IntlMessageFormat as of v9.4 has a bug that doesn't allow { in strings
    // this try/catch covers for that case

    let translation;
    const language = language$.getValue();

    try {
        translation = new IntlMessageFormat(
            currentTranslations[language]?.[key] ?? key,
            language,
            options ?? {}
        ).format(substitutions ?? {});
    } catch (error) {
        translation = key;
    }
    return translation;
}

export function changeLanguage(
    language$: BehaviorSubject<string>,
    currentTranslations: IDict<IDict<string>>,
    newLanguage: string,
    newLanguageTranslations?: IDict<string>
): void {
    // update language service to new language
    language$.next(newLanguage);

    if (newLanguageTranslations) {
        // store language translations for new language
        currentTranslations[newLanguage] = {
            ...(currentTranslations[newLanguage] || {}),
            ...newLanguageTranslations
        };
    } else if (!(newLanguage in currentTranslations)) {
        throw new Error(`No translations for ${newLanguage}`);
    }
}
